import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-sm" }

import BaseNotificationPanel from '@/components/base/BaseNotificationPanel.vue'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'OutgoingPaymentInformation'
},
  __name: 'OutgoingPaymentInformation',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseNotificationPanel, { status: "warning" }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('entry.has_upcoming_payment_paying')), 1)
    ]),
    _: 1
  }))
}
}

})